import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { HelpActions } from './help.actions';

/**
 * Coalesces help-anchor path registrations into one bulkRegisterUIPaths per tick (Bug 35599).
 * A page renders its anchors in one tick; one action each made the reducer copy uiPaths per
 * anchor (O(n^2) on a grid) and woke every store subscriber per anchor.
 */
@Injectable({ providedIn: 'root' })
export class HelpPathRegistrar {
  private pending: string[] = [];

  constructor(private store: Store) {}

  register(path: string): void {
    if (this.pending.push(path) === 1) queueMicrotask(() => this.flush());
  }

  private flush(): void {
    const paths = this.pending;
    this.pending = [];
    this.store.dispatch(HelpActions.bulkRegisterUIPaths({ paths }));
  }
}
